// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3j1on","content":"ManualTimeModal_content__2L-eZ"};